import React from 'react'
import PropTypes from 'prop-types'
import { withInfoTooltip } from 'app/core/components/InfoTooltip'
import { FormControl, FormHelperText } from '@material-ui/core'
import { compose } from 'app/utils/fp'
import Text from 'core/elements/Text'
import KeyValues, { EntryShape } from 'core/components/KeyValues'
import withFormContext from 'core/components/validatedForm/withFormContext'

// We need to use `forwardRef` as a workaround of an issue with material-ui Tooltip https://github.com/gregnb/mui-datatables/issues/595
const KeyValuesField = React.forwardRef(
  (
    {
      id,
      value,
      required,
      label = '',
      hasError,
      errorMessage,
      onChange,
      keySuggestions,
      valueSuggestions,
      blacklistedTags = [],
      keyLabel,
      valueLabel,
      allowMultipleValues = true,
      addLabel,
      additionalFields = [],
      ...restProps
    },
    ref,
  ) => (
    <FormControl id={id} error={hasError} {...restProps} ref={ref}>
      {!!label && (
        <>
          <Text variant="caption1">{required ? `${label} *` : label}</Text>
          <br />
        </>
      )}
      <KeyValues
        entries={value}
        onChange={onChange}
        keySuggestions={keySuggestions}
        valueSuggestions={valueSuggestions}
        blacklistedTags={blacklistedTags}
        addLabel={addLabel || `Add ${label}`}
        keyLabel={keyLabel}
        valueLabel={valueLabel}
        allowMultipleValues={allowMultipleValues}
        additionalFields={additionalFields}
      />
      {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  ),
)

KeyValuesField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  initialValue: PropTypes.arrayOf(EntryShape),
  blacklistedTags: PropTypes.arrayOf(PropTypes.string),
  allowMultipleValues: PropTypes.bool,
}

export default compose(
  withInfoTooltip, // This HoC causes unnecessary re-renders if declared after withFormContext
  withFormContext,
)(KeyValuesField)
